import { render, staticRenderFns } from "./BooleanRadios.vue?vue&type=template&id=46eef8e0&scoped=true&"
import script from "./BooleanRadios.vue?vue&type=script&lang=ts&"
export * from "./BooleanRadios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eef8e0",
  null
  
)

export default component.exports